import type { ModelConfig, SelectorCreator, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';

export type LocaleState = string;

const reducers = {
  set: (state: LocaleState, payload: string) => payload
};
const selectors = (slice: Slicer<LocaleState>, createSelector: SelectorCreator) => ({
  get() {
    return slice;
  },
  getClientLocale() {
    return createSelector(
      (rootState) => select.session.isAuthenticated(rootState),
      (rootState) => select.site.getCountry(rootState),
      (rootState) => select.account.getCountry(rootState) || '',
      slice,
      (authenticated, geoCountry, registeredCountry, state) => {
        const country = authenticated ? registeredCountry : geoCountry;
        return state === 'en' && country !== 'US' ? 'en-GB' : state;
      }
    );
  }
});

export interface LocaleModel extends ModelConfig<LocaleState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const locale: LocaleModel = {
  state: 'en',
  reducers,
  selectors
};

export default locale;
